import { Injectable } from "@angular/core";

import { combineLatest, Observable, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";

import { addDays, LocalStorage } from "@dffedb/util";
import { AktuelBrugerObserver, Rolle } from "@e-forsyning/common/bruger";
import { UmbracoHttpClient } from "@e-forsyning/common/http";

import { AppInfo } from "./app-info.model";

@Injectable({ providedIn: "root" })
export class AppInfoService {
    constructor(
        private readonly aktuelBrugerObserver: AktuelBrugerObserver,
        private readonly umbracoHttp: UmbracoHttpClient,
        private readonly localStorage: LocalStorage
    ) {}

    public getInfos(): Observable<AppInfo[]> {
        const noData: AppInfo[] = [];
        return this.aktuelBrugerObserver.valueChanges.pipe(
            switchMap((bruger) => (bruger && combineLatest([this.getMaaleraflaesningInfo()])) || of(noData))
        );
    }

    public getMaaleraflaesningInfo(): Observable<AppInfo> {
        const text = `Venligst indtast måleraflæsning under menupunktet "Indtast aflæsninger".`;
        const link = "#/indtast-aflaesninger";
        const afkraevAflaesningDto$ = this.umbracoHttp.hentSideData<AfkraevAflaesningDto>("indtast-aflaesninger");
        const bruger$ = this.aktuelBrugerObserver.valueChanges;
        return combineLatest([afkraevAflaesningDto$, bruger$]).pipe(
            map(([dto, bruger]) => {
                const startDato = new Date(dto.startDato);
                const slutDato = addDays(new Date(dto.slutDato), 1);
                const nu = new Date();
                const visible = bruger && Rolle.erForbruger(bruger.rolle) && nu >= startDato && nu <= slutDato;
                return { text, link, visible };
            })
        );
    }

    public onCloseAppInfo(value: AppInfo): void {
        if (value.localStorageKey) {
            this.localStorage.setItem(value.localStorageKey, "NO");
        }
    }
}

interface AfkraevAflaesningDto {
    startDato?: string;
    slutDato?: string;
}
